<ion-card class="a-modal">
  <div class="a-modal__header">
    <ion-title>Log Out</ion-title>
    <div (click)="cancel()" class="a-modal__header--closeIcon">
      <img src="assets/icons/close-icon.svg" alt="close">
    </div>
  </div>
  <div class="a-modal__body">
    <div class="tray__detail">
      <span>Are you sure you want to log out?</span>
      <span>Task in progress will not be completed.</span>
    </div>    
  </div>
  <div class="a-modal__footer">
    <div class="a-modal__footer--buttons">
      <ion-button color="light" (click)="cancel()">Cancel</ion-button>
      <ion-button color="danger" (click)="logout()">Log Out</ion-button>
    </div>
  </div>
</ion-card>